
<template>
  <div class="hours-picker">
    <div class="hours-picker__label-box">
      <label class="mx-2 hours-picker__label">
        {{label}}<span class="hours-picker__required">*</span>
      </label>
    </div>
    <div v-if="!!hours.length">
      <div class="my-2 hours-picker__container">
        <span
          v-for="hour of hours"
          :class="`hours-picker__hours${changeStyle(hour)}`"
          :key="hour.text"
          @click="selectHour(hour)"
        >
          {{hour.text}}
        </span>
      </div>
      <span class="mx-2">
        {{ timezoneWarning || $t('labels.timezoneWarning') }}
      </span>
    </div>
    <div class="hours-picker__container" v-if="hours.length === 0">
      {{ $t('components.datetimePicker.noScheduleAvailable') }}
    </div>
  </div>
</template>

<script>
import { HOURS } from '@/utils/constants';

const resetHour = () => ({
  value: '',
  available: true,
  text: ''
});

export default {
  props: {
    options: Array,
    label: String,
    timezoneWarning: String,
    changeHour: Function,
    selected: Object,
    schedule: { type: Boolean, default: false }
  },
  computed: {
    hours() {
      if (this.schedule) {
        return this.options.map(option => {
          return {
            text: option.hour.substr(0, 5),
            available: option.available,
            value: option.value
          };
        });
      } else {
        return HOURS.map(item => {
          let scheduleOption = this.options.find(
            option => option.hour.substr(0, 5) === item
          );
          return {
            text: item,
            available: scheduleOption ? scheduleOption.available : false,
            value: scheduleOption ? scheduleOption.value : null
          };
        });
      }
    }
  },
  data() {
    return {
      selectedHour: resetHour()
    };
  },
  methods: {
    selectHour(hour) {
      this.selectedHour = hour;
      this.changeHour(hour);
    },

    changeStyle(hour) {
      if (!hour.available) {
        return '-disable';
      } else if (hour.text === this.selectedHour.text) {
        return '-active';
      } else {
        return '';
      }
    }
  },
  watch: {
    options() {
      this.selectHour(resetHour());
    }
  }
};
</script>
<style lang="scss" scoped>
.hours-picker {
  margin: 10px;

  .hours-picker__required {
    color: red;
    margin: 0 8px;
  }

  &__container {
    border: 1px solid #cccccc;
    border-radius: 4px;
    padding: 10px;
    display: block;
    height: 100%;
    box-shadow: 1px 1px 5px grey;
  }

  &__hours {
    background-color: #e9e9e9;
    padding: 4px 6px;
    margin: 5px auto 5px 5px;
    display: inline-flex;
    border-radius: 16px;
    color: grey;
  }

  &__hours-active {
    background-color: #2875f3;
    padding: 4px 6px;
    margin: 5px auto 5px 5px;
    display: inline-flex;
    border-radius: 16px;
    color: white;
  }

  &__hours-disable {
    background-color: #f5f5f5;
    opacity: 0.5;
    pointer-events: none;
    user-select: none;
    padding: 4px 6px;
    margin: 5px auto 5px 5px;
    display: inline-flex;
    border-radius: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// ./src/components/fields/HoursPicker.vue